export default __webpack_public_path__ + "static/media/IMG_5262.d741df00.JPG";